<template>
  <div  class="interaction-chat__message"
        :data-id="item.id"
        :class="{
          '_you': isMe,
          '_read': item.read_message
       }">
    <div class="interaction-chat__message-head">
      <div class="interaction-chat__message-author">
        <template v-if="isMe">{{ $tInteraction('You') }}</template>
        <template v-else>{{ item.customer.firstname }}</template>
      </div>
      <div class="interaction-chat__message-date">
        <span>{{ item.created_at | formatDate }}</span>
        <span>{{ item.created_at | formatTime }}</span>
      </div>
      <div v-if="isMe"
           class="interaction-chat__message-tick">
        <BaseSvg name="ico-double-tick"/>
      </div>
    </div>
    <div class="interaction-chat__message-text" v-html="item.message"></div>
  </div>
</template>

<script>
  export default {
    name: 'InteractionChatMessage',
    props: {
      item: Object,
      userId: Number
    },
    data(vm) {
      return {
        isMe: vm.item.customer_id === vm.userId
      }
    },
    mounted() {
      if(!this.item.read_message && this.item.customer_id !== this.userId) {
        this.$emit('mounted-unread', this)
      }
    }
  }
</script>

<style lang="less">

</style>
